import React from "react";
import blueIndicatorIcon from "@src/assets/svg/blue-indicator-icon.svg";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";
import styles from "./ota-installation-in-progress-modal.module.scss";
import { useOtaInstallationInProgressModal } from "./use-ota-installation-in-progress-modal";
import { ScanLoadingLinearIndicator } from "@src/components/molecules/scan-loading-linear-indicator/scan-loading-linear-indicator";
import { Button } from "@src/components/atoms/buttons/button/button";

const cssClassName = "ota-installation-in-progress-modal";

interface OTAInstallationInProgressModalProps {
  activeInstallationData: ActiveInstallationProcessPayload;
  onClose: () => void;
}

const OTAInstallationInProgressModal = ({
  activeInstallationData,
  onClose,
}: OTAInstallationInProgressModalProps) => {
  const { texts, folders, installationProgressSteps } =
    useOtaInstallationInProgressModal(activeInstallationData);

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__overlay`]} />
      <div className={styles[`${cssClassName}__dialog-wrapper`]}>
        <div
          className={styles[`${cssClassName}__modal-body`]}
          role="dialog"
          aria-modal="true"
        >
          <div className={styles[`${cssClassName}__header`]}>
            <h2 className={styles[`${cssClassName}__title`]}>{texts.title}</h2>
            <p className={styles[`${cssClassName}__firmware-details`]}>
              {texts.installationDetailsHasItemName ? (
                <>
                  {texts.installationDetailsPrefix}
                  <span
                    className={styles[`${cssClassName}__firmware-name`]}
                    title={texts.firmwareName}
                  >
                    {texts.firmwareName}
                  </span>
                  {texts.installationDetailsSuffix}
                </>
              ) : (
                texts.installationDetails
              )}
            </p>
          </div>

          <div className={styles[`${cssClassName}__content`]}>
            <div
              className={styles[`${cssClassName}__installation-progress-steps`]}
            >
              {installationProgressSteps?.map((p, index) => {
                return (
                  <div key={index} className={styles[`${cssClassName}__step`]}>
                    <img src={blueIndicatorIcon} alt="" />
                    <span>{p}</span>
                  </div>
                );
              })}
            </div>

            <div className={styles[`${cssClassName}__folders-card`]}>
              {folders.map((folder) => (
                <div
                  key={folder}
                  className={styles[`${cssClassName}__folder-row`]}
                >
                  <img src={blueIndicatorIcon} alt="" />
                  <span className={styles[`${cssClassName}__folder-name`]}>
                    \{folder}
                  </span>
                </div>
              ))}
            </div>

            <ScanLoadingLinearIndicator />
          </div>

          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <Button
              fun={onClose}
              text={texts.pushInBackgroundButtonText}
              variant="primary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTAInstallationInProgressModal;
